import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import Feed from "@/pages/feed/page";
import Detail from "@/pages/detail/page";
import Submit from "@/pages/submit/page";
import About from "@/pages/about/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "feed", element: <Feed /> },
      { path: "detail/:id", element: <Detail /> },
      { path: "submit", element: <Submit /> },
      { path: "about", element: <About /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;